export interface ISplitTemplateParam {
  page?: number;
  size?: number;
  pagination?: boolean;
  type?: string;
  ruleName?: string;
  ruleNo?: string;
  companyId?: number;
}

export interface ISplitTemplate {
  /**  */
  id: number;
  /** 规则编号 */
  ruleNo: string;
  /** 付款标题 */
  name: string;
  /** 支付通道 */
  channelName: string;
  /** 分账方式 */
  type: ESplitType;
  /** 收款方 */
  payees: string;
  /** 分账总金额 */
  totalAmount: number;
  /** 创建时间 */
  createTime: string;
  /** 最后修改时间 */
  updateTime: string;
  /** 总比例 */
  totalPercentage: number;
}

export enum ESplitType {
  /** 固定金额 */
  AMOUNT ='AMOUNT',
  /** 固定比例 */
  RATIO = 'RATIO',
}

export const splitTypes = {
  [ESplitType.AMOUNT]: '固定金额',
  [ESplitType.RATIO]: '固定比例',
};

export interface ISplitTemplateRec {
  /** 付款标题 */
  name: string;
  /** 分账方式 */
  type: ESplitType;
  /** 规则详情列表 */
  ruleDetailVOList: IruleDetailVOList[];
  /** id */
  id?: string;
  /** 是否自留 */
  isStay?: boolean;
  stayRate?: number;
  companyId?: number;
  companyName?: string;
}

export interface IruleDetailVOList{
   /** 付款人ID */
   payeeId: string;
   /** 付款人姓名 */
   payeeName: string;
   /** 金额 */
   amount: number | null;
   /** 比例 */
   percentage: number | null;
}
